import { render } from "./MapperJob.vue?vue&type=template&id=77f05c6c"
import script from "./MapperJob.vue?vue&type=script&lang=js"
export * from "./MapperJob.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sandhiyabaskar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__